import React from 'react';

import ExpiredLinkCard from 'components/ExpiredLinkCard/ExpiredLinkCard';

const ExpiredLinkModuleContainer = () => {
    return <ExpiredLinkCard />;
};

export default ExpiredLinkModuleContainer;
